import { render } from "./App.vue?vue&type=template&id=18e30a6f"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=18e30a6f&lang=css"

import exportComponent from "D:\\CRUD Vue\\Puma Hammasi\\adidas-maincopy\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__